import * as TYPES from './types'

/**
 * Default Admin State
 */
export const defaultState: TYPES.AdminState = {
  httpInProgress: false,
  httpError: '',
  httpProjectCostsInProgress: false,
  httpProjectCostsError: '',
  adminData: undefined
}

// define initial state object
const initialState: TYPES.AdminState = {
  httpInProgress: defaultState.httpInProgress,
  httpError: defaultState.httpError,
  httpProjectCostsInProgress: defaultState.httpProjectCostsInProgress,
  httpProjectCostsError: defaultState.httpProjectCostsError,
  adminData: defaultState.adminData
}

// define admin reducer
export function adminReducer (
  state = initialState,
  action: TYPES.AdminActionTypes
): TYPES.AdminState {
  switch (action.type) {
    case TYPES.ADMIN_DASHBOARD_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpInProgress: true, httpError: '' },
        ...{ httpBlockProjectID: undefined }
      }
    }
    case TYPES.ADMIN_DASHBOARD_ERROR: {
      return {
        ...state,
        ...{ httpInProgress: false, httpError: action.error },
        ...{ httpBlockProjectID: undefined }
      }
    }
    case TYPES.ADMIN_DASHBOARD_GET: {
      return {
        ...state,
        ...{ adminData: {...action.adminData, updateTimestamp: new Date().getTime()}},
        ...{ httpInProgress: false, httpError: '' },
        ...{ httpBlockProjectID: undefined }
      }
    }
    case TYPES.ADMIN_PROJECT_COSTS_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpProjectCostsInProgress: true, httpProjectCostsError: '' }
      }
    }
    case TYPES.ADMIN_PROJECT_COSTS_ERROR: {
      return {
        ...state,
        ...{ httpProjectCostsInProgress: false, httpProjectCostsError: action.error }
      }
    }
    case TYPES.ADMIN_PROJECT_COSTS_GET: {
      return {
        ...state,
        ...{ adminData: state.adminData ? {
          ...state.adminData,
          users: state.adminData.users.map(user =>
            user.userID === action.userID
              ? {
                  ...user,
                  projects: user.projects.map(project =>
                    project.projectID === action.projectID
                      ? { ...project, billingData: action.projectBillingData }
                      : project
                  )
                }
              : user
          ),
          updateTimestamp: new Date().getTime()
        } : undefined },
        ...{ httpProjectCostsInProgress: false, httpProjectCostsError: '' }
      }
    }
    case TYPES.ADMIN_BLOCK_PROJECT: {
        return {
            ...state,
            adminData: state.adminData ? {
              ...state.adminData, 
              updateTimestamp: new Date().getTime()
            } : undefined,
            httpInProgress: false, 
            httpError: '',
            httpBlockProjectID: action.projectID
        }
    }
    default:
      return state
  }
}